import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "./firebase";

const STORAGE_KEY = "cookie-consent";
const POLICY_VERSION = "2.0";

export function getStoredConsent() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
  } catch {
    return null;
  }
}

export function saveConsent(consent) {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        analytics: !!consent.analytics,
        marketing: !!consent.marketing,
        action: consent.action,
        date: new Date().toISOString(),
        version: POLICY_VERSION,
      })
    );
  } catch {
    // localStorage non disponibile (Safari private mode): degrada silenziosamente.
  }
}

export async function logConsentToFirebase(consent) {
  try {
    await addDoc(collection(db, "cookie_consents"), {
      analytics: !!consent.analytics,
      marketing: !!consent.marketing,
      action: consent.action,
      timestamp: serverTimestamp(),
    });
  } catch {
    // Fallback silenzioso: la UX dell'utente non si blocca su errore di scrittura.
  }
}
